import { Route, Routes } from 'react-router-dom';
import { UserProfilePage } from './UserProfile';
import { Navigate } from 'react-router-dom';

export const SettingsRoutes = () => {
  return (
    <Routes>
      <Route index element={<Navigate to="profile" replace />} />
      <Route path="profile" element={<UserProfilePage />} />
    </Routes>
  );
};
